import { IResearchReferenceData } from "features/Research/types";
import { apiClient } from "lib/apiClient";

export const getResearchReferenceData =
  async (): Promise<IResearchReferenceData> => {
    const response = await apiClient.get("/research/reference-data");

    return response.data;
  };
